import { useIsMobile } from '~/composables/useIsMobile';
import {
  MOBILE_HOME_PATH,
  isMobileAllowedPath,
  isRootPath,
  toComparablePath,
} from '~/utils/authRoutes';
import { hydrationSafeNavigateTo } from '~/utils/hydrationSafeNavigation';

/**
 * 手機版路由守衛
 *
 * 手機版沒有側欄、也沒有把每一頁做 RWD：能出現的頁面只有白名單那幾個
 * （見 `isMobileAllowedPath`），其餘一律導去對話首頁。
 *
 * 排在 auth.global 之後（global middleware 依檔名排序）：
 * 未登入的人會先被 auth 送去登入頁，走到這裡的一定是已登入且組織就緒的人。
 * 根路徑留給 redirect.global 送去 dashboard，dashboard 再由這裡接手導去對話首頁。
 */
export default defineNuxtRouteMiddleware((to) => {
  if (!useIsMobile().value) return;
  if (isRootPath(to.path)) return;

  const path = toComparablePath(to.path);
  if (isMobileAllowedPath(path)) return;

  return hydrationSafeNavigateTo(useNuxtApp(), useLocalePath()(`/${MOBILE_HOME_PATH}`), {
    replace: true,
  });
});
